export const manyPolicemanXlsxColumns = {
  // contato
  contato_do_agente: "",

  // user
  nome_do_agente: "",
  email_do_agente: "",
  senha_do_agente: "",
  rg_do_agente: "",
  cpf_do_agente: "",
  cnpj_do_agente: "",

  // policeman
  agente_publico: "",
  agente_esta_trabalhando: "",
  regiao_do_agente: "",
  valor_km_adicional_patrimonial_agente: "",
  valor_hora_adicional_patrimonial_agente: "",
  valor_saida_patrimonial_agente: "",
  valor_km_adicional_veicular_agente: "",
  valor_hora_adicional_veicular_agente: "",
  valor_saida_veicular_agente: "",
  valor_franquia_por_km: "",

  // address
  rua_do_endereco: "",
  numero_do_endereco: "",
  cidade_do_endereco: "",
  bairro_do_endereco: "",
  UF_do_endereco: "",

  // bankingData
  dados_bancarios_dados_da_conta_banco: "",
  dados_bancarios_dados_da_conta_conta: "",
  dados_bancarios_dados_da_conta_agencia: "",
  dados_bancarios_dados_da_conta_pix: "",
  dados_bancarios_dados_da_conta_tipo_do_pix: "",
};

export type ManyPolicemanColumnsTypes = keyof typeof manyPolicemanXlsxColumns;
